import { defineMessages } from 'react-intl';

export default defineMessages({
  validationRequiredLogin: {
    id: 'components.login.validation.required.login',
    defaultMessage: 'Login is a required field',
  },
  validationRequiredPassword: {
    id: 'components.login.validation.required.password',
    defaultMessage: 'Password is a required field',
  },
  placeholderLogin: {
    id: 'components.login.form.placeholder.login',
    defaultMessage: 'Login',
  },
  placeholderPassword: {
    id: 'components.login.form.placeholder.password',
    defaultMessage: 'Password',
  },
  loginButton: {
    id: 'components.login.form.loginButton',
    defaultMessage: 'LogIn',
  },
  signupButton: {
    id: 'components.login.form.signupButton',
    defaultMessage: 'Register',
  },
  rememberMe: {
    id: 'components.login.form.rememberMe',
    defaultMessage: 'Remember me',
  },
  forgotPassword: {
    id: 'components.login.form.forgotPassword',
    defaultMessage: 'Forgot password',
  },
});



// WEBPACK FOOTER //
// ./src/components/Login/messages.js